import { Stack } from '@mui/material';
import { QRIconContainer, StyledCardContainer } from './Filter.components';
import { Grid, PrimaryButton } from '@/components';
import BarcodeScanner from 'react-qr-barcode-scanner';
import QrCodeScannerOutlinedIcon from '@mui/icons-material/QrCodeScannerOutlined';
import { useState } from 'react';
import { ScanQrModal } from './ScanQRDialog';
import { useBoolean } from 'usehooks-ts';

export const FirstSection = () => {
  const { value: shouldShowQrDialog, toggle: toggleShowQrDialog } =
    useBoolean();
  const [data, setData] = useState<string>('');

  return (
    <Stack>
      <QRIconContainer onClick={toggleShowQrDialog}>
        <QrCodeScannerOutlinedIcon fontSize="inherit" color="inherit" />
      </QRIconContainer>

      <ScanQrModal
        open={shouldShowQrDialog}
        isPending={false}
        onClose={toggleShowQrDialog}
        title="Scan QR"
        content={
          <Stack>
            <BarcodeScanner
              width={400}
              height={400}
              facingMode="environment"
              onUpdate={(_, result) => {
                if (result) setData(result.getText());
                else setData('Not Found');
              }}
            />

            <p>{data}</p>
          </Stack>
        }
        cancelActionTitle="Cancel"
        confirmActionTitle="Scan"
        onConfirm={() => console.log()}
        onCancel={toggleShowQrDialog}
      />
    </Stack>
  );
};
